var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailBulkSolid = function SvgMailBulkSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none",
    className: "svgr-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mail-bulk-solid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#445A64",
    d: "M2.857 0v7.143H0v9.286h12.143V13.57H20V4.286h-5V0zm1.429 1.429h9.285v2.857H7.143v2.857H4.286zM8.57 5.714h10v6.429h-6.428v-5H8.57zM15 7.143V8.57h2.143V7.143zM1.429 8.57h9.285v.796l-4.313 2.681a.63.63 0 0 1-.659 0L1.43 9.368zm9.285 2.478V15H1.43v-3.95l3.558 2.212a2.034 2.034 0 0 0 2.167-.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mail-bulk-solid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v16.429H0z"
  })))));
};
export default SvgMailBulkSolid;